import * as Sentry from '@sentry/vue';
import {axios} from '@js/utilities/axios.js';

export default {
	namespaced: true,
	state: {
		user: {
			id: null,
			name: null,
			email: null,
			phone: null,
			type: null,
			timezone: null,
			country: null,
			legacyPermissions: {
				is_admin: 0
			},
			permissions: {},
			roles: [],
			onboarding_status: {}
		},
	},
	getters: {
		user(state) {
			return state.user
		},
		id(state) {
			return state.user.id
		},
		name(state) {
			return state.user.name
		},
		email(state) {
			return state.user.email
		},
		phone(state) {
			return state.user.phone
		},
		type(state) {
			return state.user.type
		},
		timezone(state) {
			return state.user.timezone
		},
		country(state) {
			return state.user.country
		},
		isAdmin(state) {
			return !!state.user.legacyPermissions.is_admin
		},
		isCleaner(state) {
			return state.user.is_cleaner;
		},
		isClient(state) {
			return state.user.is_client;
		},
		candidateListConfig(state) {
			return state.user.candidate_list_config
		},
		canRefund(state) {
			return !!state.user.legacyPermissions.can_refund
		}
	},
	actions: {
		login(context, {email, password}) {
			return new Promise((resolve, reject) => {
				axios.post('/login', {
					email: email,
					password: password,
				}).then(() => {
					resolve()
				}).catch((error) => {
					reject(error)
				})
			})
		},
		logout(context) {
			context.commit('setUser', null)
			context.commit('setToken', null)
			localStorage.removeItem('token')
		},
		fetchUser(context) {
			return new Promise((resolve, reject) => {
				axios.get('/api/user', {}).then((response) => {
					context.commit('setUser', response.data.data)
					if (import.meta.env.PROD) {
						const user = response.data.data;
						Sentry.setUser({
							id: user.id,
							email: user.email,
							username: user.name,
						});
					}
					resolve(response)
				}).catch((error) => {
					reject(error)
				})
			})
		},
		fetchCurrentUser(context) {
			return new Promise((resolve, reject) => {
				axios.get('/api/user').then((response) => {
					context.commit('setCurrentUser', response.data.data)
					resolve()
				}).catch((error) => {
					reject(error.response)
				})
			})
		},
		updateCard(context, token) {
			return new Promise((resolve, reject) => {
				axios.post('/api/account/update-card', {
					token: token
				}).then((response) => {
					resolve(response)
				}).catch((error) => {
					reject(error)
				})
			})
		},
		deleteCard() {
			return new Promise((resolve, reject) => {
				axios.delete('/api/account/card').then((response) => {
					resolve(response)
				}).catch((error) => {
					reject(error)
				})
			})
		}

	},
	mutations: {
		setCurrentUser(state, user) {
			state.user = user
		},
		setUser(state, user) {
			state.user = user
		},
		addUnfinishedRecord(state, record) {
			state.user.unfinished_records.push(record);
		},
		removeUnfinishedRecord(state, record) {
			state.user.unfinished_records = state.user.unfinished_records.filter(item => {
				return item.id !== record.id;
			});
		}
	}
}
